import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import AuthService from '../services/authService';
import { logout, setUserData } from '../actions/accountActions';
import { clearPersistedStorage } from '../store/persistor';

function useAuth() {
  const dispatch = useDispatch();
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    const initAuth = async (): Promise<void> => {
      AuthService.setAxiosInterceptors({
        onLogout: async () => {
          await dispatch(logout());
          await clearPersistedStorage();
        },
      });
      AuthService.handleAuthentication();
      if (AuthService.isAuthenticated()) {
        const user = await AuthService.loginInWithToken();
        if (user) {
          dispatch(setUserData(user));
        }
      }

      setLoading(false);
    };

    initAuth();
  }, [dispatch]);

  return { isLoading };
}

export default useAuth;
